var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: () => _vm.$emit("reset-search"),
          expression: "() => $emit('reset-search')",
        },
      ],
    },
    [
      _c("div", { attrs: { id: _vm.autocompleteContainterId } }),
      _vm._v(" "),
      _c("div", { ref: "suggestions", staticClass: "search-suggestions" }, [
        _c("div", { attrs: { id: _vm.autocompletePanelId } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.searchTerm,
                expression: "searchTerm",
              },
            ],
            staticClass:
              "dropdown-menu autosuggest-menu__list autosuggest-outer-list suggestions-list",
          },
          [
            _c(
              "div",
              { staticClass: "suggestions-list__item" },
              [
                _c("ais-configure", {
                  attrs: { hitsPerPage: 3, ruleContexts: _vm.ruleContext },
                }),
                _vm._v(" "),
                _c("h3", { staticClass: "list__title" }, [
                  _vm._v("Top Equipment"),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "autosuggest-inner-list" },
                  [
                    _c("ais-hits", {
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ items, sendEvent }) {
                            return [
                              _vm._l(items, function (item) {
                                return _c(
                                  "li",
                                  {
                                    key: item.objectID,
                                    staticClass: "autosuggest-list-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onClick(
                                          item,
                                          sendEvent,
                                          _vm.suggestionClickLabel
                                        )
                                      },
                                    },
                                  },
                                  [
                                    item.name
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "sqItemImage" },
                                            [
                                              item.image
                                                ? _c("img", {
                                                    attrs: {
                                                      onload:
                                                        "this.parentNode.style.display = 'block'",
                                                      onerror:
                                                        "this.src='/ResourcePackages/Main/assets/static_assets/img_placeholder.png'",
                                                      src: item.image ?? "",
                                                      alt: item.name,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    { staticClass: "no-image" },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "camera_icon",
                                                        attrs: {
                                                          src: "/ResourcePackages/Main/assets/static_assets/img_placeholder.png",
                                                          alt: "No image available",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "sqItemContent" },
                                            [
                                              _c("ais-highlight", {
                                                attrs: {
                                                  attribute: "name",
                                                  hit: item,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }),
                              _vm._v(" "),
                              items.length == 0
                                ? _c(
                                    "li",
                                    {
                                      staticClass:
                                        "autosuggest-menu__item pad_item",
                                    },
                                    [_vm._v("No Results")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "suggestions-list__viewMore",
                    on: {
                      click: function ($event) {
                        return _vm.hashQuery("#equipment")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    View all equipment results\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "suggestions-list__item" },
              [
                _c(
                  "ais-index",
                  { attrs: { "index-name": _vm.partsIndexName } },
                  [
                    _c("query-rule-custom-data-extended"),
                    _vm._v(" "),
                    _c("ais-configure", {
                      attrs: { ruleContexts: _vm.ruleContext },
                    }),
                    _vm._v(" "),
                    _c("h3", { staticClass: "list__title" }, [
                      _vm._v("Top Parts"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "autosuggest-inner-list" },
                      [
                        _c("ais-hits", {
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ items, sendEvent }) {
                                return [
                                  _vm._l(items, function (item) {
                                    return _c(
                                      "li",
                                      {
                                        key: item.objectID,
                                        staticClass: "autosuggest-list-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClick(
                                              item,
                                              sendEvent,
                                              _vm.suggestionClickLabel
                                            )
                                          },
                                        },
                                      },
                                      [
                                        item.name
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "sqItemImage" },
                                                [
                                                  item.image
                                                    ? _c("img", {
                                                        attrs: {
                                                          onload:
                                                            "this.parentNode.style.display = 'block'",
                                                          onerror:
                                                            "this.src='/ResourcePackages/Main/assets/static_assets/img_placeholder.png'",
                                                          src: item.image ?? "",
                                                          alt: item.name,
                                                        },
                                                      })
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "no-image",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "camera_icon",
                                                            attrs: {
                                                              src: "/ResourcePackages/Main/assets/static_assets/img_placeholder.png",
                                                              alt: "No image available",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "sqItemContent",
                                                },
                                                [
                                                  _c("ais-highlight", {
                                                    attrs: {
                                                      attribute: "name",
                                                      hit: item,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._v(" "),
                                  items.length == 0
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "autosuggest-menu__item pad_item",
                                        },
                                        [_vm._v("No Results")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "suggestions-list__viewMore",
                        on: {
                          click: function ($event) {
                            return _vm.hashQuery("#parts")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        View all parts & supplies\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "suggestions-list__item" },
              [
                _c(
                  "ais-index",
                  { attrs: { "index-name": _vm.contentIndexName } },
                  [
                    _c("query-rule-custom-data-extended"),
                    _vm._v(" "),
                    _c("ais-configure", {
                      attrs: { ruleContexts: _vm.ruleContext },
                    }),
                    _vm._v(" "),
                    _c("h3", { staticClass: "list__title" }, [
                      _vm._v("Top Pages"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "autosuggest-inner-list" },
                      [
                        _c("ais-hits", {
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ items, sendEvent }) {
                                return [
                                  _vm._l(items, function (item) {
                                    return _c(
                                      "li",
                                      {
                                        key: item.objectID,
                                        staticClass: "autosuggest-list-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClick(
                                              item,
                                              sendEvent,
                                              _vm.suggestionClickLabel
                                            )
                                          },
                                        },
                                      },
                                      [
                                        item.title
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "sqItemContent",
                                                },
                                                [
                                                  _c("ais-highlight", {
                                                    attrs: {
                                                      attribute: "title",
                                                      hit: item,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._v(" "),
                                  items.length == 0
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "autosuggest-menu__item pad_item",
                                        },
                                        [_vm._v("No Results")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "suggestions-list__viewMore",
                        on: {
                          click: function ($event) {
                            return _vm.hashQuery("#pages")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        View all web pages\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "ais-index",
                  { attrs: { "index-name": _vm.resourcesIndexName } },
                  [
                    _c("query-rule-custom-data-extended"),
                    _vm._v(" "),
                    _c("ais-configure", {
                      attrs: { ruleContexts: _vm.ruleContext },
                    }),
                    _vm._v(" "),
                    _c("h3", { staticClass: "list__title" }, [
                      _vm._v("Top Resources"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "autosuggest-inner-list" },
                      [
                        _c("ais-hits", {
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ items, sendEvent }) {
                                return [
                                  _vm._l(items, function (item) {
                                    return _c(
                                      "li",
                                      {
                                        key: item.objectID,
                                        staticClass: "autosuggest-list-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClick(
                                              item,
                                              sendEvent,
                                              _vm.suggestionClickLabel
                                            )
                                          },
                                        },
                                      },
                                      [
                                        item.title
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "sqItemContent",
                                                },
                                                [
                                                  _c("ais-highlight", {
                                                    attrs: {
                                                      attribute: "title",
                                                      hit: item,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }),
                                  _vm._v(" "),
                                  items.length == 0
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "autosuggest-menu__item pad_item",
                                        },
                                        [_vm._v("No Results")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "suggestions-list__viewMore",
                        on: {
                          click: function ($event) {
                            return _vm.hashQuery("#resources")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        View all resources\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }